/**
 * This file contains API function for login modules.
 */
import {http} from 'utils/http';

/**
 * Expected Input data
 */
export interface LoginInput {
	username: string;
	password: string;
	recaptcha: string;
}

/**
 * Expected Output data
 */
export interface LoginSuccess {
	auth_token: string;
}

// ROUTE
export const apiLoginRoute = () => '/token/login/';
// API FUNCTION
export const apiLogin = (input: LoginInput) => {
	// console.log(apiLoginRoute(), input);
	return http.post<LoginSuccess>(apiLoginRoute(), input);
};
